<template>
  <div class="w-full fixedHeight">
    <!-- Navbar container with dynamic background -->
    <div 
      :style="{ background: pageBackground }" 
      class="relative border-[#202F2B] shadow-[0px_4px_30px_rgba(240,239,239,1)] z-50 flex flex-row justify-between w-full h-24"
    >
      <!-- Header and Navigation -->
      <header class="relative flex items-center justify-between w-full text-2xl font-medium p-6 text-zinc-100 h-full">
        
        <!-- Logo on the left -->
        <router-link to="/" class="md:w-auto">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/b36db72682e1efc034696b2254ee56a9212df5e90c2bda7b8c14d25164183a9f?placeholderIfAbsent=true&apiKey=d64a437ab8f64a9ca8fc16914b2d583b"
            alt="Company logo"
            class="object-contain pointer top-4 w-44 relative md:right-0 right-11 h-28 max-md:w-48"
          />
        </router-link>

        <!-- Navigation Links for Desktop -->
        <nav class="hidden relative top-6 mb-10 md:flex gap-12">
          <router-link to="/ButtonGroup" class="text-white">Work</router-link>
          <router-link to="/AboutHolePageDesign" class="text-white">About</router-link>
          <a @click="scrollToFooter" class="text-white cursor-pointer">Contact</a>
          <a  
            href="/assets/Parinistha-Sharma._ Resume.pdf" 
            download
            class="text-white cursor-pointer"
          >
            Resume
            <font-awesome-icon class="text-white text-2xl" icon="file-arrow-down" />
          </a>
        </nav>

        <!-- Burger Icon for Mobile -->
        <button
          @click="toggleMenu"
          class="md:hidden text-white focus:outline-none z-20"
        >
          <!-- Conditionally render the burger icon -->
          <svg
            v-if="!isMenuOpen"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            class="w-8 h-8"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <!-- Mobile Navigation Links -->
        <nav
          :class="[ 
            'flex flex-col gap-6 mt-2 absolute top-2 left-0 w-full bg-white text-slate-700 z-10 p-6',
            isMenuOpen ? 'block' : 'hidden'
          ]"
        >
          <!-- Exit Icon for Mobile Menu -->
          <button
            @click="toggleMenu"
            class="absolute top-4 right-4 text-black focus:outline-none"
          >
            <!-- Close Icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="black"
              class="w-8 h-8"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <router-link to="/ButtonGroup" v-slot="{ navigate }">
            <a class="text-slate-700" @click.stop="navigateAndCloseMenu(navigate)">Work</a>
          </router-link>
          <router-link to="/AboutHolePageDesign" v-slot="{ navigate }">
            <a class="text-slate-700" @click.stop="navigateAndCloseMenu(navigate)">About</a>
          </router-link>
          <a @click.stop="navigateAndCloseMenu(scrollToFooter)" class="text-slate-700 cursor-pointer">Contact</a>
          <a 
            href="/assets/Parinistha-Sharma._ Resume.pdf" 
            download
            class="text-slate-700 cursor-pointer"
            @click.stop="navigateAndCloseMenu"
          >
            Resume
            <font-awesome-icon class="text-slate-700 text-2xl" icon="file-arrow-down" />
          </a>
        </nav>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainNavbar",
  props: {
    pageBackground: {
      type: String,
      default: 'transparent'
    }
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    navigateAndCloseMenu(callback) {
      this.isMenuOpen = false;
      this.$nextTick(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    },
    scrollToFooter() {
      const footer = document.getElementById('footer');
      if (footer) {
        footer.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>

<style scoped>
.fixedHeight {
  height: 100px;
}
</style>
